import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { buttonBaseStyles, getFocusStyles, getVariantStyles, getWidthStyles, sizeStyles } from './styles';
import { getResponsiveStyleObject } from "../../shared/utils/responsive/responsive";
function Button(props) {
    const { component, children, variant = 'primary', size = 'medium', color = 'blue', fullWidth = false, leftIcon, rightIcon, isSelected = false, disabled = false, type, ref, ...componentProps } = props;
    const Component = component || 'button';
    const buttonProps = {};
    if (Component === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    }
    else {
        if (disabled) {
            buttonProps['aria-disabled'] = disabled;
        }
    }
    return (_jsxs(Component, { ref: ref, css: [
            buttonBaseStyles,
            getFocusStyles(color, variant),
            getWidthStyles(fullWidth),
            getResponsiveStyleObject(size, (size) => sizeStyles[size]),
            getVariantStyles(variant, color, isSelected), // variant styles must come after sizeStyles in order to override padding for link variant
        ], "data-disabled": disabled || undefined, tabIndex: disabled ? -1 : 0, ...buttonProps, ...componentProps, children: [leftIcon ? _jsx("span", { css: { marginRight: '1rem', display: 'inline-flex' }, children: leftIcon }) : null, children, rightIcon ? _jsx("span", { css: { marginLeft: '1rem', display: 'inline-flex' }, children: rightIcon }) : null] }));
}
/**
 * A component that allows users to take actions, and make choices, with a single tap
 */
export { Button };
